import { z } from 'zod';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
export const shipTransferOrderPickInputSchema = z.object({
    itemId: lowercasedRequiredUuidString('Line item is required.', 'Invalid line item selection.'),
    qtyPicked: z
        .number()
        .refine(Number.isFinite, 'Picked quantity must be a number.')
        .min(0, 'Picked quantity cannot be negative.'),
});
//# sourceMappingURL=ship-transfer-order-pick-input.js.map